import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import SEOHead from '../components/SEO/SEOHead';

const PrivacyPolicyPage: React.FC = () => (
  <Box sx={{ maxWidth: 800, mx: 'auto' }}>
    <SEOHead
      title="Privacy Policy"
      description="Hooliah's privacy policy — how we collect, use, and protect your data."
      canonicalUrl="https://hooliah.com/privacy-policy"
    />

    <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 1 }}>Privacy Policy</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>Last updated: June 2025</Typography>

    <Typography variant="body1" paragraph>
      At Hooliah ("we", "us", "our"), we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website hooliah.com and use our services.
    </Typography>

    <Divider sx={{ my: 3 }} />

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>1. Information We Collect</Typography>
    <Typography variant="body1" paragraph>
      We collect information you provide directly, including your name, email address, profile picture (via Google OAuth), uploaded outfit images, ratings, comments, and any content you submit through our platform. We also collect usage data such as pages visited, features used, device information, and IP addresses.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>2. Google AdSense & Cookies</Typography>
    <Typography variant="body1" paragraph>
      We use Google AdSense to display advertisements on our platform. Google AdSense uses cookies and similar technologies to serve ads based on your prior visits to our website and other websites. Google's use of advertising cookies enables it and its partners to serve ads based on your visit to Hooliah and/or other sites on the Internet. You may opt out of personalized advertising by visiting Google's Ads Settings at <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">www.google.com/settings/ads</a>.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>3. How We Use Your Information</Typography>
    <Typography variant="body1" paragraph>
      We use your information to provide and improve our services, personalize your experience, process your uploads and ratings, communicate with you, display relevant advertisements, analyze usage patterns, and ensure platform safety and security.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>4. Cookies & Tracking Technologies</Typography>
    <Typography variant="body1" paragraph>
      We use cookies, web beacons, and similar tracking technologies to collect usage data, remember your preferences, and serve targeted advertisements. You can control cookie preferences through your browser settings. Disabling cookies may affect some features of our platform.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>5. Your Data Rights</Typography>
    <Typography variant="body1" paragraph>
      You have the right to access, correct, or delete your personal data. You can update your profile information through your account settings. To request data deletion, contact us at privacy@hooliah.com. We will respond to your request within 30 days.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>6. Data Sharing</Typography>
    <Typography variant="body1" paragraph>
      We do not sell your personal information. We may share data with service providers (AWS, Google) who help us operate our platform, and with law enforcement when required by law. Third-party advertisers may collect anonymized data through cookies as described above.
    </Typography>

    <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>7. Contact Us</Typography>
    <Typography variant="body1" paragraph>
      If you have questions about this Privacy Policy, please contact us at privacy@hooliah.com.
    </Typography>
  </Box>
);

export default PrivacyPolicyPage;
